import * as React from 'react';
import ConfirmationModal from 'src/share/components/ConfirmationModal/ConfirmationModal';
import { useAuthModal } from 'src/modules/Auth/AuthModal/useAuthModal';
import { useCurrentRoute } from 'src/modules/Routing/auth/useCurrentRoute';
import { useRoutes } from 'src/modules/Routing/hooks/routes/useRoutes';

export const AuthModal: React.SFC = () => {
  const [state, actions] = useAuthModal();
  const [currentRoute] = useCurrentRoute()
  const [routes] = useRoutes();
  const [isPrivate, setIsPrivate] = React.useState(false)
  React.useEffect(() => {
    const route = routes.find((publicRoute) => publicRoute.path === currentRoute.path)
    setIsPrivate(route && route.policies.length > 0 ? true : false)
  }, [routes, currentRoute])
  return isPrivate ? (
    <ConfirmationModal
      isOpen={state.isModalOpen}
      toggle={actions.logout}
      title={'Session expired'}
      description="Would you like to continue logged?"
      onContinue={actions.refreshSession}
    />) : null
}